import { api } from "@/lib/api";

/* PDF som bakgrunnsjobb: start → poll → last ned. Tåler treg prod (ingen 100 s-grense) og gir framdrift. */
const sov = (ms) => new Promise((r) => setTimeout(r, ms));

export async function downloadDeckPdf({ deck, mottaker = "", kategori = "", token = "", filePrefix, fresh = false, onProgress }) {
  const params = {};
  if (token) params.r = token;                 // offentlig: anonymt mottakertoken
  else {
    if (mottaker) params.mottaker = mottaker;  // admin
    if (kategori) params.kategori = kategori;
  }
  if (fresh) params.fresh = 1;
  let { data: st } = await api.post(`/deck/${deck}/pdf/jobs`, null, { params });
  const t0 = Date.now();
  let savnet = 0;
  while (st.status !== "done") {
    if (st.status === "error") throw new Error(st.error || "PDF failed");
    if (Date.now() - t0 > 8 * 60 * 1000) throw new Error("PDF took too long — try again");
    onProgress?.(st.progress ?? 0);
    await sov(1500);
    try {
      st = (await api.get(`/deck/pdf/jobs/${st.jobId}`)).data;
      savnet = 0;
    } catch (e) {
      /* 404 = jobben finnes ikke i denne instansen ennå (flere instanser) eller serveren startet på nytt — vent litt før vi gir opp */
      if (e?.response?.status === 404 && ++savnet <= 20) continue;
      throw new Error(e?.response?.data?.detail || (e?.response?.status === 404 ? "PDF job was lost (server restarted) — try again" : e.message));
    }
  }
  onProgress?.(100);
  const res = await api.get(`/deck/pdf/jobs/${st.jobId}/download`, { responseType: "blob", timeout: 120000 });
  const served = /filename="?([^";]+)"?/.exec(res.headers?.["content-disposition"] || "")?.[1];
  const a = document.createElement("a");
  a.href = URL.createObjectURL(res.data);
  a.download = served || `${filePrefix}${mottaker ? `-${mottaker.split(/\s+/).join("-")}` : ""}.pdf`;
  a.click();
  URL.revokeObjectURL(a.href);
}
